import { useQuery } from '@tanstack/react-query';

import { QuestionnairesApi } from 'api/QuestionnairesApi';
import { BANK_QUESTIONNAIRE_KEY } from 'tanstack-hooks/keys';
import { useUser } from 'tanstack-hooks/user';

export function useBankQuestionnaire(questionnaireId = '', version = 'latest') {
  const questionnairesApi = new QuestionnairesApi();
  const { userBankId } = useUser();

  const { data: questionnaire, isLoading: isLoadingBankQuestionnaire } = useQuery({
    enabled: !!userBankId.length && !!questionnaireId.length,
    queryKey: [BANK_QUESTIONNAIRE_KEY, userBankId, questionnaireId, version],
    queryFn: () => questionnairesApi.getQuestionnaire(userBankId, questionnaireId, version)
  });

  return { questionnaire, isLoadingBankQuestionnaire };
}
